import React from 'react';
import { Loader } from '../../Loaders';
import { Dimmer, Image, Segment } from 'semantic-ui-react';
import * as CollaborationLoaderUI from './CollaborationLoaderUI';

export default () => (
  <>
    <CollaborationLoaderUI.Container className={'chart-loader'}>
      <Segment>
        <Dimmer active inverted />
        <Image
          src="/images/loader.png"
          style={{ width: '100%', height: '200px' }}
        />
      </Segment>
      <Loader />
      <Segment>
        <Dimmer active inverted />
        <Image
          src="/images/loader.png"
          style={{ width: '100%', height: '200px' }}
        />
      </Segment>
    </CollaborationLoaderUI.Container>
  </>
);
